import React, { useState, useContext, useEffect } from "react"
import { UserContext } from "src/context/UserContext"
import { CompleteSignUpForm } from "src/components/partials/booking/infoPersonal/info/personal-details/completeSignUp"
import { CompleteSignInForm } from "src/components/partials/booking/infoPersonal/info/personal-details/completeSignIn"
import { CompleteUserDetails } from "src/components/partials/booking/infoPersonal/info/personal-details/completeUserDetails"
import { Input } from "src/components/core/atoms/input"
import Card from "src/components/core/atoms/card"

import {
  cardContainer,
  innerContainer,
  inputContainer,
  inputBox,
} from "src/components/partials/booking/infoPersonal/personal.module.css"

export const PersonalDetails = ({ input, isLoggedIn }) => {
  const [isValid, setIsValid] = useState("not-valid")
  const { checkEmail, user } = useContext(UserContext)

  const check = async email => {
    const res = await checkEmail(email)
    console.log({ res })
    if (!res) {
      setIsValid("new-email")
    } else {
      setIsValid("existing-email")
    }
    return res
  }

  const checkIsValidEmail = e => {
    const isValid = !!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
      e.target.value
    )
    if (isValid) {
      const email = e.target.value
      check(email)
    } else {
      setIsValid("not-valid")
    }
    input.setValues({ ...input.values, email: e.target.value })
  }

  const updateValues = React.useCallback(() => {
    input.setValues({
      ...input.values,
      email: user.email,
    })
  }, [input, user])

  useEffect(() => {
    if (isLoggedIn) {
      updateValues()
    }
  }, [isLoggedIn, updateValues])

  return (
    <div className={cardContainer}>
      <Card title="Your Details">
        {isLoggedIn ? (
          <CompleteUserDetails user={user} />
        ) : (
          <>
            <div className={innerContainer}>
              <div className={inputContainer}>
                <p>Email</p>
                <Input.Field
                  type="email"
                  value={input.values.email}
                  onChange={checkIsValidEmail}
                  className={inputBox}
                  name="email"
                />
                <Input.ErrorMessage name="email" input={input} />
              </div>
            </div>
            {isValid !== "existing-email" && (
              <CompleteSignUpForm
                input={input}
                disabled={isValid === "not-valid"}
              />
            )}
            {isValid === "existing-email" && <CompleteSignInForm />}
          </>
        )}
      </Card>
    </div>
  )
}

export default PersonalDetails
